import { Box, ModalHeader, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { Chat } from '../../Chat'
import { WriskTrans } from '../../trans'

const tKey = TKey('components.missing-document-modal')

export const MissingDocumentModal: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <Typo>
        <WriskTrans
          t={t}
          i18nKey={tKey('content')}
          components={{
            Chat: <Chat />,
          }}
        />
      </Typo>
    </Box>
  )
}
